<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
        <h4>司机管理</h4>
    </div> -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="绑定车牌号">
            <el-input size="mini" v-model.trim="searchFrom.vehicleNo" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input size="mini" v-model.trim="searchFrom.mobilePhone" placeholder=""></el-input>
          </el-form-item>
          <div style="margin:10px;">
            <el-form-item>
              <el-button type="primary" @click="searchFn" btnCode="01K0050100" v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" @click="resetForm" btnCode="01K0050200" v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary" @click="addDir" btnCode="01K0050300" v-if="btnFlg[2]">新增</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
        <el-table :data="tableList" ref="table" bordersize="mini" @selection-change='selectGoods' style="width: 100%"
            height="100%" center border class="tableComent">
            <el-table-column type="index" prop="date" width="180" label="操作" align="center">
                <template slot-scope="scope">
                    <!-- 1显示通过/驳回 ，不是1显示记录 -->
                    <div>
                        <el-button type="text" btnCode="01K0050600" size="mini" v-if="btnFlg[5]" @click="shanchu(scope.row)">删除</el-button>
                        <el-button type="text" btnCode="01K0050400" size="mini" v-if="btnFlg[3]" @click="addCar(scope.row)">新增车辆</el-button>
                        <el-button type="text" btnCode="01K0050500" size="mini" v-if="btnFlg[4]" @click="changeCar(scope.row)">修改车辆</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column property="account" label="司机账号"></el-table-column>
            <el-table-column property="mobilePhone" label="手机号"></el-table-column>
            <el-table-column prop="vehicleNos" label="绑定车牌号"></el-table-column>
            <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
        </el-table>
    </div>
    <!-- 分页 -->
    <div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="searchFrom.pageNo" :page-sizes="[20, 30, 40, 50]" :page-size="searchFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
    <el-dialog title="新增司机" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addDirShow"
        width="30%" center>
        <div style="width:100%; margin:15px auto;">
            <el-form :model="addDirFrom" :rules="rules" ref="addDirFrom" class="demo-form-inline" label-width="180px"
                size="mini">
                <el-form-item label="手机号:" prop="account">
                    <el-input placeholder="请输入手机号" maxlength="20" v-model="addDirFrom.account"
                        style="width:190px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addDirOK('addDirFrom')">确 定</el-button>
            <el-button @click="addDirShow = false">取 消</el-button>
        </span>
    </el-dialog>
    <el-dialog title="新增车辆" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addCarShow"
        width="30%" center>
        <div style="width:80%; margin:15px auto;">
            <el-form :model="addCarFrom" :rules="rules" ref="addCarFrom" class="demo-form-inline" label-width="130px"
                size="mini">
                <el-form-item label="车牌号:" prop="vehicleNo">
                    <el-input placeholder="请输入车牌号" maxlength="20" v-model="addCarFrom.vehicleNo"
                        style="width:190px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addCarOK('addCarFrom')">确 定</el-button>
            <el-button @click="addCarShow = false">取 消</el-button>
        </span>
    </el-dialog>
    <el-dialog title="修改车辆" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="changeCarShow"
        width="50%" center>
        <div style="width:80%; margin:15px auto;">
            <el-form v-for=" (item, index) in changeTable" :key="index" :model="item" :ref="'changeCarFrom' + index"
                :rules="rules" label-width="150px" class="demo-ruleForm" style="margin-bottom:20px;background:#fff;">

                <!-- <el-form :model="changeCarFrom" :rules="rules" ref="changeCarFrom" class="demo-form-inline" label-width="130px"
                size="mini"> -->
                <el-form-item label="车牌号:" prop="vehicleNo">
                    <el-input placeholder="请输入车牌号" maxlength="20" v-model="item.vehicleNo"
                        style="width:190px;"></el-input>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button type="text" @click="baoCunCar(item, index)">保存<i class="el-icon-edit"></i></el-button>
                    <el-button type="text" @click="detCar(item, index)">删除<i class="el-icon-delete"></i></el-button>
                </el-form-item>
            </el-form>
        </div>

    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  // 列表查询
  cVhcNoColour // 车辆颜色
} from '@/api/consignment'
import { driverVehicleList, deleteDriver, addDriver, addPcDriverVehicle, updateDriverVehicle, deleteDriverVehicle, getPcDriverVehicle } from '@/api/lj'
export default {

  data () {
    return {
      h: 500,
      rules: {
        account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile
        ],
        vehicleNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ]
      },
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      addDirShow: false,
      addCarShow: false,
      changeCarShow: false,
      addDirFrom: {},
      addCarFrom: {},
      changeCarFrom: {},
      tableList: [],
      changeTable: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      btnFlg: [],
      btnIdArr: ['01K0050100', '01K0050200', '01K0050300', '01K0050400', '01K0050500', '01K0050600']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/driverManagement')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
  },
  methods: {
    shanchu (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          deleteDriver({
            id: row.id
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.getList(this.searchFrom)
              loading.close()
            })
            .catch((err) => {
              loading.close()

              DonMessage.error(err.message)
            })
        })
        .catch(() => { })
    },
    addDir () {
      this.addDirShow = true
    },
    addCar (row) {
      this.addCarShow = true
      this.row = row
      this.addCarFrom = {}
    },
    changeCar (row) {
      this.row = row
      getPcDriverVehicle({ id: row.id }).then(res => {
        if (res.length !== 0) {
          this.changeTable = res

          this.changeCarShow = true
        } else {
          this.$message({
            message: '请先新增车辆',
            type: 'error'
          })
        }
      }).catch(err => {
        loading.close()
        DonMessage.error(err.message)
      })
    },
    baoCunCar (item, index) {
      if (item.vehicleNo !== '') {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.$set(this.changeCarFrom, 'id', this.row.id)
        updateDriverVehicle({ id: item.id, vehicleNo: item.vehicleNo }).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(err => {
          loading.close()
          DonMessage.error(err.message)
        })
      } else {
        this.$message({
          message: '车牌号不能为空',
          type: 'error'
        })
      }
    },
    detCar (item, index) {
      if (item.vehicleNo !== '') {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.$set(this.changeCarFrom, 'id', this.row.id)
        deleteDriverVehicle({ id: item.id, vehicleNo: item.vehicleNo }).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
          getPcDriverVehicle({ id: this.row.id }).then(res => {
            if (res.length !== 0) {
              this.changeTable = res
            } else {
              this.changeCarShow = false

              // this.$message({
              //     message: "暂无可修改车辆",
              //     type: "error",
              // });
            }
          }).catch(err => {
            loading.close()
            DonMessage.error(err.message)
          })
        }).catch(err => {
          loading.close()
          DonMessage.error(err.message)
        })
      } else {
        this.$message({
          message: '车牌号不能为空',
          type: 'error'
        })
      }
    },
    addCarOK (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.$set(this.addCarFrom, 'id', this.row.id)
          addPcDriverVehicle(this.addCarFrom).then(res => {
            this.addCarShow = false
            this.getList(this.searchFrom)
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            loading.close()
          }).catch(err => {
            loading.close()
            DonMessage.error(err.message)
          })
        } else {
          return false
        }
      })
    },
    addDirOK (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addDriver(this.addDirFrom).then(res => {
            this.addDirShow = false
            this.getList(this.searchFrom)
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            loading.close()
          }).catch(err => {
            loading.close()
            DonMessage.error(err.message)
          })
        } else {
          return false
        }
      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      driverVehicleList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        platformStatuss: [2004, 2005],
        noWayType: 3,
        settlementMethod: 1
      }
      this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
    margin-left: 10px;
}

.inpBox .el-date-editor {
    width: 350px !important;
}
</style>
